var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am-button',{attrs:{"name":_vm.name,"label":_vm.label,"icon":_vm.icon,"variant":_vm.variant,"icon-only":_vm.iconOnly,"loading":_vm.loading,"tool-tip-text":_vm.toolTipText,"loading-text":"Uploading..."},on:{"click":_vm.upload}})}
var staticRenderFns = []

export { render, staticRenderFns }